import { useState } from 'react';

interface DownloadProps {
  fileName: string;
  url: string;
}

export default function useDownloadFile() {
  const [isLoading, setIsLoading] = useState(false);

  const download = async ({ fileName, url: fileUrl }: DownloadProps) => {
    setIsLoading(true);

    try {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return { download, isLoading };
}
